import Snippet from '../../components/Snippet/Snippet'
import { table } from '../../assets/code-snippets/table/snip'

const Table = () => {

    return <div className="container fluid py-2" id="intro">

        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Table in POKE-CSS</p>
        </div>

        <div className="spacer md"></div>

        <div className="row align-items-center">
            <div className="col md-III">

                <div className="container md">
                    <Snippet code={table} language='html' />
                </div>

            </div>
            <div className="col md-III">
                <div className="table rounded-md shadow-sm" padding="2" table-hover="true" table-striped="true" table-align="center">
                    <table>
                        <thead>
                            <tr>
                                <th>Head</th>
                                <th>Head</th>
                                <th>Head</th>
                                <th>Head</th>
                                <th>Head</th>
                                <th>Head</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                            <tr>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                                <td>Cell</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div className="container fluid py-3">
            <div className="table rounded-md shadow-sm" padding="3" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Main</th>
                            <th>Additional</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>div</td>
                            <td><code>.table</code></td>
                            <td><code>table</code> tag element is wrapped into this div having the class of <code>.table</code> in order to apply all styles and also responsivness</td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td><code>.table.auto</code></td>
                            <td>When applied along <code>.table</code> class, <code>.auto</code> will align to center the entire table element, if a certain width is defined on this</td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td><code className='text primary'>table-striped="true"</code></td>
                            <td>Will create stripes on 'even' <code>td</code> element</td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td><code className='text primary'>table-hover="true"</code></td>
                            <td>Will create the <code>td</code> hover effect</td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ul>
                                    <li><code className="text primary">table-align="left"</code></li>
                                    <li><code className="text primary">table-align="center"</code></li>
                                    <li><code className="text primary">table-align="right"</code></li>
                                </ul>
                            </td>
                            <td>Will align text in each cell respectively</td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">cell-padding="0"</code></li>
                                    <li><code className="text primary">cell-padding="1"</code></li>
                                    <li><code className="text primary">cell-padding="2"</code></li>
                                    <li><code className="text primary">cell-padding="3"</code></li>
                                    <li><code className="text primary">cell-padding="4"</code></li>
                                    <li><code className="text primary">cell-padding="5"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply certain padding within all <code>td</code> cells:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>0px</li>
                                    <li>5px</li>
                                    <li>10px</li>
                                    <li>15px</li>
                                    <li>20px</li>
                                    <li>25px</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">head-padding="0"</code></li>
                                    <li><code className="text primary">head-padding="1"</code></li>
                                    <li><code className="text primary">head-padding="2"</code></li>
                                    <li><code className="text primary">head-padding="3"</code></li>
                                    <li><code className="text primary">head-padding="4"</code></li>
                                    <li><code className="text primary">head-padding="5"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply certain padding within all <code>th</code> cells:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>0px</li>
                                    <li>5px</li>
                                    <li>10px</li>
                                    <li>15px</li>
                                    <li>20px</li>
                                    <li>25px</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">padding="0"</code></li>
                                    <li><code className="text primary">padding="1"</code></li>
                                    <li><code className="text primary">padding="2"</code></li>
                                    <li><code className="text primary">padding="3"</code></li>
                                    <li><code className="text primary">padding="4"</code></li>
                                    <li><code className="text primary">padding="5"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply certain padding within all cells:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>0px</li>
                                    <li>5px</li>
                                    <li>10px</li>
                                    <li>15px</li>
                                    <li>20px</li>
                                    <li>25px</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">cell-spacing="1"</code></li>
                                    <li><code className="text primary">cell-spacing="2"</code></li>
                                    <li><code className="text primary">cell-spacing="3"</code></li>
                                    <li><code className="text primary">cell-spacing="4"</code></li>
                                    <li><code className="text primary">cell-spacing="5"</code></li>
                                    <li><code className="text primary">cell-spacing="6"</code></li>
                                    <li><code className="text primary">cell-spacing="7"</code></li>
                                    <li><code className="text primary">cell-spacing="8"</code></li>
                                    <li><code className="text primary">cell-spacing="9"</code></li>
                                    <li><code className="text primary">cell-spacing="10"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply <code>border-collapse: separate</code> & <code>border-spacing</code> having a value of:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>1px</li>
                                    <li>2px</li>
                                    <li>3px</li>
                                    <li>4px</li>
                                    <li>5px</li>
                                    <li>6px</li>
                                    <li>7px</li>
                                    <li>8px</li>
                                    <li>9px</li>
                                    <li>10px</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">cell-border="1"</code></li>
                                    <li><code className="text primary">cell-border="2"</code></li>
                                    <li><code className="text primary">cell-border="3"</code></li>
                                    <li><code className="text primary">cell-border="4"</code></li>
                                    <li><code className="text primary">cell-border="5"</code></li>
                                    <li><code className="text primary">cell-border="6"</code></li>
                                    <li><code className="text primary">cell-border="7"</code></li>
                                    <li><code className="text primary">cell-border="8"</code></li>
                                    <li><code className="text primary">cell-border="9"</code></li>
                                    <li><code className="text primary">cell-border="10"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply <code>border: solid</code> to <code>th</code> & <code>td</code> elements having a value of:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>1px</li>
                                    <li>2px</li>
                                    <li>3px</li>
                                    <li>4px</li>
                                    <li>5px</li>
                                    <li>6px</li>
                                    <li>7px</li>
                                    <li>8px</li>
                                    <li>9px</li>
                                    <li>10px</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                            <td>div</td>
                            <td>
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li><code className="text primary">table-border="1"</code></li>
                                    <li><code className="text primary">table-border="2"</code></li>
                                    <li><code className="text primary">table-border="3"</code></li>
                                </ol>
                            </td>
                            <td>
                                Will apply <code>border: solid</code> to table element having a value of:
                                <ol style={{ listStyle: 'lower-alpha' }}>
                                    <li>5px</li>
                                    <li>10px</li>
                                    <li>20px</li>
                                </ol>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

}

export default Table